export default __webpack_public_path__ + "static/media/poke-dux-mini.64a30c28.png";